<div class="position-relative w-100 padding">
  <app-main-detail></app-main-detail>
  <app-sub-detail></app-sub-detail>
  <app-itax-app></app-itax-app>
    <app-itax-market></app-itax-market>
  <div class="py-10px">
    <app-itax-other-products></app-itax-other-products>
  </div>
</div>
